import { Pipe, PipeTransform, inject } from '@angular/core';
import { QuestionTableService } from '../question-table-service/question-table.service';

@Pipe({
  name: 'displayTable',
})
export class DisplayTablePipe implements PipeTransform {
  private readonly questionTableService: QuestionTableService =
    inject(QuestionTableService);

  public transform(value: string): string {
    return this.questionTableService.tablesJsonToQuestionTableData(value)
      .questionWithTablePlaceholders;
  }
}
